import React from 'react'
import { BOOT_TIMER_OPTIONS, DEFAULT_BOOT_AFTER_SECONDS } from '@warcarp/api-types'
import { CompactOptionSelector } from './CompactOptionSelector'
import type { SetupLayout } from './setup/SetupControls'

const OPTIONS = BOOT_TIMER_OPTIONS.map(option => ({ value: option.seconds, label: option.label }))

export function BootTimerSelector({ value, onChange, ...field }: {
  value: number; onChange: (seconds: number) => void; layout?: SetupLayout; changed?: boolean; separated?: boolean
}) {
  // A value outside the list (legacy or hand-edited rows) shows the default.
  const shown = OPTIONS.some(option => option.value === value) ? value : DEFAULT_BOOT_AFTER_SECONDS
  return <CompactOptionSelector
    {...field}
    title="Boot timer"
    value={shown}
    options={OPTIONS}
    onChange={onChange}
    pillTestID="boot-timer-selector"
    optionTestID={seconds => `boot-timer-${seconds}`}
    helpLabel="What is the boot timer?"
    helpMessage="Anyone else in the game can boot a player who holds the turn past this timer. A bot takes their seat, and the game counts as abandoned for that player. Players on vacation cannot be booted. Every boot requires confirmation, and the game log shows who booted whom."
  />
}
